import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import shipmentReducer from './slices/shipmentSlice';
import notificationReducer from './slices/notificationSlice';
import unclaimedPackagesReducer from './slices/unclaimedPackagesSlice';
import statusDefinitionsReducer from './slices/statusDefinitionsSlice';
import systemSettingsReducer from './slices/systemSettingsSlice';
import currenciesReducer from './slices/currenciesSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    shipments: shipmentReducer,
    notifications: notificationReducer,
    unclaimedPackages: unclaimedPackagesReducer,
    statusDefinitions: statusDefinitionsReducer,
    systemSettings: systemSettingsReducer,
    currencies: currenciesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/setCredentials'],
      },
    }),
});

export default store;
